<script lang="ts">
  interface IQuotePanel {
    author: string;
    quote: string;
  }
  export let data: IQuotePanel;
</script>

<div class="quote-panel">
  <div class="quote-panel__symbol">”</div>
  <div class="quote-panel__message">{@html data?.quote}</div>
  {#if data?.author}
    <div class="quote-panel__author">- {data?.author}</div>
  {/if}
</div>

<style lang="scss">
  .quote-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    margin: 30px 0 90px;

    &__symbol {
      text-align: center;
      position: absolute;
      font-size: 30px;
      transform: scale(7);
      padding-top: 8px;
      color: #dedede;
    }

    &__author {
      @include normal;
      color: $text-color;
    }

    &__message {
      @include h2;
      padding: 0 120px;
      position: relative;
      z-index: 12;
      line-height: 1.5;
      margin-bottom: 16px;
      word-break: break-word;

      @include sm-down {
        padding: 0 20px;
      }
    }
  }
</style>
